export const DownloadAppBanner = () => {

  const $body = $('body')
  const $banner = $('.js-downloadAppBanner--fixed')
  const $closeBtn = $banner.find('.js-downloadAppBanner__closeBtn')

  if ($body.length && $banner.length && $closeBtn.length) {
    initFixedBanner()
  }

  function initFixedBanner() {
    if (localStorage.getItem('downloadAppBannerClosed') !== 'true') {
      $banner.removeClass('c-downloadAppBanner--hide')
    }

    $closeBtn.on('click', function(event) {
      event.preventDefault()
      $banner.addClass('c-downloadAppBanner--hide')
      localStorage.setItem('downloadAppBannerClosed', 'true');
    })

  }

}